// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-258f7254],.part-title .fr[data-v-258f7254]{color:#ff3973;cursor:pointer}.part-title .fr[data-v-258f7254]{width:100px;height:30px;line-height:30px;border:1px solid #ff3973;border-radius:4px;font-size:14px;text-align:center}", ""]);
// Exports
module.exports = exports;
